import request from '@/utils/request';
// import { getToken } from "@/utils/auth"; // get token
import configR from '@/configs.js';
const API = configR.envConfigs.PORTAL_API;
// 获取新闻栏目
export function getNewsColumn(data) {
  return request({
    url: `${API}v1/cms/Column/getColumnList`,
    method: "get"
  });
}

// 获取新闻列表
export function getNewsList(data) {
  return data.request({
    url: `${data.serveUrl}v1/cms/content/getColumncontents?kw=${
      data.kw
    }&columnId=${data.ColumnId}&pageNo=${data.pageNo}&pageSize=${
      data.pageSize
    }&loadContent=${
      data.loadContent
    }&loadPicContents=${
      data.loadPicContents
    }`,
    method: "get",
    headerType: data.header
  });
}
// 获取新闻列表
export function getTotalNewsList(data) {
  return data.request({
    url: `${data.serveUrl}v1/cms/newInfos?kw=${
        data.kw
    }&columnId=${data.ColumnId}&pageNo=${data.pageNo}&pageSize=${
        data.pageSize
    }&loadContent=${
        data.loadContent
    }&loadPicContents=${
        data.loadPicContents
    }`,
    method: "get",
    headerType: data.header
  });
}
// 获取Rss新闻
export function getRssContent(data) {
  return data.request({
    url: `${data.serveUrl}v1/cms/content/getRssContents?columnId=${data.ColumnId}&pageNo=${data.pageNo}&pageSize=${
      data.pageSize
    }`,
    method: "get",
    headerType: data.header
  });
}
// 查看新闻正文
export function getNewsContent(data) {
  return data.request({
    url: `${data.serveUrl}v1/cms/content/getOne?id=${data.id}`,
    method: "get",
    headerType: data.header
  });
}

// 查看新闻正文
export function getHotCms(data) {
  return data.request({
    url: `${data.serveUrl}v1/cms/content/getHotCms`,
    method: "get",
    headerType: data.header,
    params: data.params
  });
}


// 收藏资讯取消收藏
export function postNewsCollect(data) {
  return data.request({
    url: `${data.serveUrl}v1/cms/content/collect?id=${data.id}&type=${
      data.type
    }`,
    method: "post",
    headerType: data.header
  });
}
// 记录资讯阅读
export function writeReadRecord(data) {
  return data.request({
    url: `${data.serveUrl}v2/cms/${data.contentId}/writeReadRecord`,
    method: "post"
  });
}

